export default __webpack_public_path__ + "static/ghost_happy-dba5c19b5693e0989ff1d26905a4899c.svg";